export const knowOurInvestmentsLink = 'https://www.terrainvestimentos.com.br/invista/';
